export { useAppRouter, type AppRouter } from './useAppRouter';
